<template>
  <div>
    <OneGoal :showGoal="showGoal" @close="showGoal = false"></OneGoal>
    <transition name="fade">
      <div
        v-show="loading"
        class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
      >
        <Loader class="center-h-v" />
      </div>
    </transition>

    <div class="m-2" style="border-radius: 0.5rem;">

      <BehavioralAssessment v-if="pending.length===0 && drafts.length===0" />
      <el-collapse
          accordion
          v-model="activeItem"
          @change="handleItemClick"
          v-for="(reviews, type) in reviewGroups"
          :key="type"
          :class="type"
      >
        <el-collapse-item
            :name="review.ObjectiveId"
            v-for="review in reviews"
            :key="review.ObjectiveId"
            class="mt-3"
        >
          <template slot="title">
            <div class="complete-circle"></div>
            <h1 class="font-bolder d-inline-block">{{ review.GoalName }}</h1>
          </template>

          <main
              class="bg-gray-200 py-2 px-4 w-full"
              v-if="infoByReviewId[review.ObjectiveId]"
          >
            <section class="w-full my-2">
              <div class="flex w-full items-center gap-4">
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Name:</h1>
                  <small class="text-sm">{{ review.GoalName }}</small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Measure:</h1>
                  <small class="text-sm">{{ review.GoalMeasure }}</small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Goal Weight:</h1>
                  <small class="text-sm">{{ review.Weight || 0 }}%</small>
                </div>
                <div class="flex items-center gap-2">
                  <h1 class="font-bold text-lg">Target:</h1>
                  <small class="text-sm">{{ review.Target }}</small>
                </div>
              </div>
            </section>

            <article class="my-2">
              <header>
                <h1 class="font-bold text-lg">Description</h1>
              </header>
              <div>
                <p v-if="!loading">{{ review.Description }}</p>
                <el-skeleton
                    :rows="3"
                    animated
                    v-if="loading"
                    :loading="loading"
                    variant="text"
                    style="width: 80%"
                />
              </div>
            </article>

            <section class="bg-white w-full rounded-lg">
              <header
                  class="w-full border-b-1.5 flex justify-between items-center"
              >
                <h1 class="text-lg font-bold p-2">My Assessment</h1>
                <div class="flex gap-2">
                  <p
                      :style="{
                'background-color':
                  infoByReviewId[review.ObjectiveId].myReview.ObjectiveStatus === 'Draft'
                    ? '#87CEEB'
                    : '#4CAF50',
                color: '#fff',
                padding: '1px 8px',
                'border-radius': '5px',
              }"
                      class="mr-2"
                  >
                    {{
                      infoByReviewId[review.ObjectiveId].myReview.ObjectiveStatus
                    }}
                  </p>
                </div>
              </header>

              <main class="flex flex-col gap-2">
                <section class="flex gap-2">
                  <div class="flex w-full items-center p-2">
                    <div class="flex flex-col w-full">
                      <h1 class="font-bold text-lg">Achieved Target</h1>
                      <el-skeleton
                          :rows="1"
                          animated
                          v-if="loading"
                          :loading="loading"
                          variant="text"
                          style="width: 80%"
                      />
                      <input
                          v-if="!loading"
                          :type="review.GoalMeasure"
                          class="bg-gray-200"
                          v-model="info.AchievedTarget"
                          required
                      />
                    </div>
                  </div>
                  <div class="flex w-full items-center p-2">
                    <div class="flex flex-col w-full">
                      <h1 class="font-bold text-lg">Attachment</h1>
                      <el-skeleton
                          :rows="1"
                          animated
                          v-if="loading"
                          :loading="loading"
                          variant="text"
                          style="width: 80%"
                      />
                      <input
                          v-if="!loading && !info.Attachment"
                          type="file"
                          multiple
                          class="bg-gray-200 p-2"
                          v-on:change="getFile"
                      />
                      <el-button
                          v-if="!loading && info.Attachment"
                          type="plain"
                          @click="showAttachedDocs = true"
                      >
                        View Attached Files
                      </el-button>
                    </div>
                  </div>

                  <div class="flex w-full items-center p-2">
                    <div class="flex w-full items-center p-2">
                      <div class="flex flex-col w-full">
                        <h1 class="font-bold text-lg">Rating</h1>
                        <el-skeleton
                            :rows="1"
                            animated
                            v-if="loading"
                            :loading="loading"
                            variant="button"
                            style="width: 80%"
                        />
                        <select
                            v-if="!loading"
                            class="bg-gray-200"
                            v-model="info.Rating"
                            required
                        >
                          <option value="5">Exceeding Expectations</option>
                          <option value="4">Meeting Expectations</option>
                          <option value="3">
                            Meeting Expectations with Reservations
                          </option>
                          <option value="2">Approaching Expectations</option>
                          <option value="1">Below Expectations</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </section>
                <div class="p-4">
                  <label>Comment </label>
                  <el-skeleton
                      :rows="3"
                      animated
                      v-if="loading"
                      :loading="loading"
                      variant="text"
                      style="width: 90%"
                  />
                  <textarea
                      v-if="!loading"
                      name="myreview-comment"
                      id="myreview-comment"
                      cols="5"
                      rows="5"
                      class="w-full p-2 border-1.5 rounded bg-gray-200"
                      style="width: 100% !important"
                      v-model="info.Comment"
                  ></textarea>
                </div>
              </main>
            </section>

            <section
                class="flex gap-2 justify-end my-2"
                v-if="infoByReviewId[review.ObjectiveId].myReview.ObjectiveStatus === 'Draft'"
            >
              <el-button
                  type="info"
                  class="rounded-full"
                  @click="handleSubmit('draft')"
              >
                Save as Draft
              </el-button>
              <el-button type="warning" @click="handleSubmit('final')">
                Submit
              </el-button>
            </section>
          </main>
        </el-collapse-item>
      </el-collapse>
      <div
        v-if="!loading && reviews.length == 0"
        class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>
    </div>
    <PerfReviewAttachments
      :showAttachedDocs="showAttachedDocs"
      :info="info"
      @close="showAttachedDocs = false"
    ></PerfReviewAttachments>
  </div>
</template>

<script>
import axios from 'axios';
import OneGoal from './oneGoal.vue';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import PerfReviewAttachments from '@/components/employees/modals/perfReviewAttachments.vue';
import BehavioralAssessment from "@/components/PerformanceReview/myreviews/behavioralAssessment";
export default {
  name: 'MyReviewsGoals',
  components: { OneGoal, Loader, PerfReviewAttachments, BehavioralAssessment },
  data() {
    return {
      showGoal: false,
      loading: false,
      showAttachedDocs: false,
      activeItem: '',
      activeObjective:[],
      infoByReviewId: {},
      completed:[],
      drafts:[],
      pending:[],
      selectedObjectiveId:"",
      info: {
        ObjectiveReviewId: '',
        ObjectiveId: '',
        ObjectiveStatus: 'Draft',
        ReviewType: 'Mine',
        Rating: '',
        AchievedTarget: '',
        Attachment: '',
        Comment: '',
      },
      columns: [
        {
          field: 'Name',
          key: 'a',
          title: 'Objective Name',
          renderBodyCell: ({ row }) => {
            return (
              <p
                on-click={() => (this.showGoal = true)}
                class='text-blue-500 cursor-pointer'
              >
                {row.Name}
              </p>
            );
          },
        },
        { field: 'Category', key: 'b', title: 'Category' },
        /*  { field: "DueDate", key: "c", title: "Due Date" }, */
        {
          field: 'MyReview',
          key: 'x',
          title: 'My Review',
        },
        {
          field: 'Attachment',
          key: 'd',
          title: 'Attachment',
          renderBodyCell: () => {
            return <p class='cursor-pointer font-bold'>&#128206;</p>;
          },
        },
        {
          field: 'Feedback',
          key: 'f',
          title: 'Feedback',
          renderBodyCell: () => {
            return (
              <img
                class='h-6 object-contain cursor-pointer px-5'
                src='@/assets/icons/cross-white.png'
              />
            );
          },
        },
      ],
      reviews: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
    reviewGroups() {
      return {
        pending: this.pending,
        drafts: this.drafts,
        completed: this.completed,
      };
    },
  },
  methods: {
    getFile({ target }) {
      const file = target.files[0];
      this.info.Attachment = file;
      const blob = new Blob([file], { type: '*' });
      this.preview = URL.createObjectURL(blob);
    },
    handleItemClick(ObjectiveId) {
      this.selectedObjectiveId = ObjectiveId
      const activeReview = this.reviews.find(
          (review) => review.ObjectiveId === ObjectiveId
      );

      if (!activeReview) {
        console.error(`Objective with ID ${ObjectiveId} not found.`);
        return;
      }
      const myReviews =
          activeReview.Reviews.find((review) => review.ReviewType === "Mine") || {
            AchievedTarget: "",
            Attachment: "",
            Comment: "",
            Rating: null,
            ObjectiveStatus: "Draft",
            ReviewType: "Mine",
          };
      this.$set(this.infoByReviewId, ObjectiveId, {
        ObjectiveId,
        myReview: myReviews,
      });
      this.info = {
        ObjectiveId,
        ...this.info,
        ...myReviews,
      };
      this.activeObjective = activeReview;
      this.loading = false;
    },

    fetchData() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        params:{
          type:'mine'
        }
      };
      const apiUrl = `${this.getOrganization}/performance/objective/mine/${this.$ApiVersion}/request`;
      axios
        .get(apiUrl, options)
        .then((response) => {
          if (response.data.StatusCode == 200) {
            this.reviews = response.data.Data;
            this.completed = this.reviews.filter(item=>item.Reviews.some(review=>review.ReviewType==="Mine" && review.ObjectiveStatus==="Submitted"))
            this.drafts = this.reviews.filter(item=>item.Reviews.some(review=>review.ReviewType==="Mine" && review.ObjectiveStatus==="Draft"))
            this.pending = this.reviews.filter(item=>item.Reviews.length===0)
            this.loading = false;
          } else {
            this.$notify.error({
              title: 'Failure',
              message: 'Error occured while fetching data.',
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: 'Failure',
            message: 'Error occured while fetching records.',
          });
          console.error('Error fetching data:', error);
        });
    },
    getStatusImagePath(status) {
      return require(`@/assets/icons/status-${status}.png`);
    },
    refresh() {
      this.fetchData();
    },
    async postData(data) {
      this.loading = true;
      const action = data.get("ObjectiveReviewId") === "undefined" ? "add" : "edit";
      const verb = data.get("ObjectiveReviewId") === "undefined" ? "post" : "put";
      let response;
      try {
        const apiUrl = `${this.getOrganization}/performance/objective/review/${this.$ApiVersion}/${action}`;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'multipart/form-data',
          },
        };
        response = await axios[verb](apiUrl, data, options);
        if (response.data.StatusCode === 200) {
          this.loading = false;
          this.$notify({
            title: 'Success',
            message: response.data.StatusMessage,
            type: 'success',
          });
          this.fetchData();
          setTimeout(()=>{
            this.handleItemClick(this.selectedObjectiveId)
          }, 2000)
        } else {
          this.loading = false;
          throw new Error(`Unexpected status code: ${response.status}`);
        }
      } catch (error) {
        this.loading = false;
        this.loading = false;
        this.$notify.error({
          title: 'Failure',
          message: response.data.StatusMessage,
        });
        console.error('Error in API call:', error);
      }
    },
    handleSubmit(status) {
      const formData = new FormData();
      formData.append(
        'ObjectiveId',
        status === 'draft' ? this.activeObjective.ObjectiveId : this.activeObjective.ObjectiveId
      );
      formData.append('ObjectiveReviewId', this.info.ReviewId);
      formData.append('ReviewType', 'Mine');
      formData.append('Rating', parseInt(this.info.Rating, 10));
      formData.append('AchievedTarget', this.info.AchievedTarget);
      formData.append('Attachment', this.info.Attachment);
      formData.append('Comment', this.info.Comment);
      if (status === 'final') {
        formData.append('ObjectiveStatus', 'Submitted');

        this.postData(formData);
      } else {
        formData.append('ObjectiveStatus', 'Draft');

        this.postData(formData);
      }
    },
  },
};
</script>
<style>
.complete-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 2rem;
}
.completed .el-collapse-item__header, .pending .el-collapse-item__header, .drafts .el-collapse-item__header {
  background-color: #f1f1f1 !important;
}
.completed .el-collapse-item__header .complete-circle {
  background-color: #02a81a !important;
}
.drafts .el-collapse-item__header .complete-circle {
  background-color: #fd791d !important;
}
.pending .el-collapse-item__header .complete-circle {
  background-color: #0e0b0b !important;
}
.el-collapse {
  border: none !important;
}
</style>
